import React, { Component } from "react";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import MetaTags from "react-meta-tags";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import SafeHTML from "components/buttons/SafeHTML";
//import "./css/landing.css"
class PreviewPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      previewData: null, 
    };

   
  }

  componentDidMount() {
    const { match: { params }
    } = this.props;
    const { location } = this.props;
    if (location.state && location.state.previewData) {
      this.setState({ previewData: location.state.previewData });
    } 
    
  }


 

  render() {
   const  { previewData } = this.state;
   
    return (
      <React.Fragment>
        <ToastContainer autoClose={2000} />
       
          <MetaTags>
            <title> Realty Space</title>
          </MetaTags>
       
         <SafeHTML html={previewData?.projectLandingPage?.landingPageFullContent} />
        {/* <div
          dangerouslySetInnerHTML={{
            __html: previewData?.projectLandingPage?.landingPageFullContent || "Loading content..."
          }}
        />  */}
     
      </React.Fragment>
    );
  }
}




PreviewPage.propTypes = {
  t: PropTypes.any,
  match: PropTypes.object,
  history:PropTypes.object,
  location:PropTypes.object
};
export default connect()(withTranslation()(PreviewPage));

